(function () {
  var fab = document.getElementById('nomad-wa-fab');
  if (!fab) return;

  if (document.body && fab.parentNode !== document.body) {
    document.body.appendChild(fab);
  }

  fab.style.position = 'fixed';
  fab.style.top = 'auto';
  fab.style.left = 'auto';
  fab.style.transform = 'none';
  fab.removeAttribute('hidden');

  var PHONE = '13056978076';
  var TEXT = 'Hola, me gustaría saber más sobre sus libros';

  fab.addEventListener('click', function (e) {
    var web = fab.getAttribute('href');
    var isMobile = /Android|iPhone|iPad|iPod|Mobi/i.test(navigator.userAgent);

    if (isMobile) {
      e.preventDefault();
      var start = Date.now();
      window.location.href =
        'whatsapp://send?phone=' + PHONE + '&text=' + encodeURIComponent(TEXT);
      setTimeout(function () {
        if (Date.now() - start < 1600) {
          window.open(web, '_blank', 'noopener');
        }
      }, 900);
      return;
    }

    e.preventDefault();
    var w = 480;
    var h = 740;
    var x = Math.max(0, (screen.width - w) / 2);
    var y = Math.max(0, (screen.height - h) / 2);
    var win = window.open(
      web,
      'whatsapp_chat',
      'noopener,width=' + w + ',height=' + h + ',left=' + x + ',top=' + y,
    );
    if (!win) {
      window.open(web, '_blank', 'noopener');
    }
  });
})();
